export default __webpack_public_path__ + "static/media/home-shape.2c2a6ab1.png";